<template>
  <resource-box :name=resourceName>
    <div class="warpper" slot="content">
      <div class="echarts" id="main"></div>
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/IndustryMap/components/resourceBox.vue';
import * as echarts from 'echarts';
export default {
  name: 'growingTrends',
  components: {
    resourceBox,
  },
  props:{
    growthTrendData:{
      type:Array,
      default:function (){
        return []
      }
    }
  },
  watch:{
    growthTrendData:{
      handler:function (val){
        this.option.dataset[0].source = val
        this.myChart.setOption(this.option);
      }
    }
  },
  data() {
    return {
      resourceName:this.$store.state.echartsMap.lowerLevelData.typeName + '增长趋势',
      option: {
        grid: {
          top: 50,
          left: 50,
          right: 50,
          bottom: 50,
        },
        dataset: [
          {
            // 每个维度的信息
            dimensions: ['name', 'value'],
            // 目标数组，相当于 serise 中的 data
            source: [],
          },
          // 数据转换器
          {
            transform: {
              type: 'sort', // 排序
              config: {
                dimension: 'value', // 映射字段 value
                order: 'desc', // 倒叙
              },
            },
          },
        ],
        xAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(143,143,143,0.76)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            fontSize: 14,
            fontWeight: 500,
            color: '#ffffff',
            opacity: 1,
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(143,143,143,0.76)',
            },
          },
          axisLabel: {
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(143,143,143,0.76)',
            },
          },
        },
        series: [
          {
            type: 'pictorialBar',
            symbol: 'rect',
            symbolMargin: "4", //图形垂直间隔
            symbolSize: [21, 5], // 图形大小 [width，height]
            color: 'rgba(4,16,30,1)', // 柱形图颜色
            symbolRepeat: true, // 图形是否重复
            z: 12,
            zlevel: 12,
            symbolBoundingData: 20000, // 指定图形界限的值
            symbolPosition: 'start', // 符号位置在柱子末端
            label: {
              show: true,          // 开启显示
              position: 'top',     // 位置，可选'top', 'inside', 'bottom', 'left', 'right'等
              color:'#fff',
              fontSize: 14,
            }
          },
          {
            type: 'bar',
            barWidth: 20,
            barSize:'',
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(0, 255, 238, 1)' },
                  { offset: 1, color: 'rgba(0, 40, 173, 1)' }
                ]
              }
            }
          },
        ],
      },
    };
  },
  mounted() {
    this.initEcharts()
    // 监听窗口大小变化
    window.addEventListener('resize', function() {
      this.myChart.resize();
    });
  },
  methods:{
    initEcharts(){
      let chartDom = document.getElementById('main');
      this.myChart = echarts.init(chartDom);
      this.myChart.setOption(this.option);
    }
  }
};
</script>

<style lang="less" scoped>
.warpper {
  width: 100%;
  height: 100%;
  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
